define('modules/media/video',['require','exports','module','modules/media/binder','app','videojs'],function(require, exports, module) {//"use strict";

	var Binder = require("modules/media/binder");
	var app = require("app");
	var videojs = require("videojs");

	var VideoMod = {

		type : "video",
		poster : {},
		player : {},

		load : function(modules_cfg, type, el, media, elements) {

			if (!el.getAttribute('is_loaded') && _.isEmpty(this.player)) {

				//TODO controllo supporto video nativo  ed eventuale integrazione  (mediaelements/videojs)
				//this.add_player (el);

				this.player = el;

				var sources = this.player.querySelectorAll('source');
				var l = sources.length;
				var j = 0;

				//TODO sorgenti video
				_.map(sources, function(e, i) {

					// sources[j][]

					e.src = media[e.type];

				});

				this.poster = elements.querySelectorAll('.video-poster')[0];
				this.scan = elements.querySelectorAll('.scanner')[0];

				//el.autoplay=true;

				this.Bind(modules_cfg, el, elements.id);

			} else {

				////console.log ('video già assegnato');

			}

		},

		add_player : function(el) {

			//////console.log (id);

			this.player = new MediaElementPlayer('#' + el.id, {
				// if the <video width> is not specified, this is the default
				//defaultVideoWidth : 480,
				// if the <video height> is not specified, this is the default
				//defaultVideoHeight : 270,
				// if set, overrides <video width>
				//videoWidth : -1,
				// if set, overrides <video height>
				//videoHeight : -1,
				// width of audio player
				audioWidth : 400,
				// height of audio player
				audioHeight : 30,
				// initial volume when the player starts
				startVolume : 0.8,
				// useful for <audio> player loops
				loop : false,
				// enables Flash and Silverlight to resize to content size
				enableAutosize : true,
				// the order of controls you want on the control bar (and other plugins below)
				//features : ['playpause', 'progress', 'current', 'duration', 'tracks', 'volume', 'fullscreen'],
				// Hide controls when playing and mouse is not over the video
				alwaysShowControls : false,
				// force iPad's native controls
				iPadUseNativeControls : false,
				// force iPhone's native controls
				//	iPhoneUseNativeControls : true,
				// force Android's native controls
				//		AndroidUseNativeControls : true,
				// forces the hour marker (##:00:00)
				alwaysShowHours : false,
				// show framecount in timecode (##:00:00:00)
				//showTimecodeFrameCount : false,
				// used when showTimecodeFrameCount is set to true
				//framesPerSecond : 25,
				// turns keyboard support on and off for this instance
				enableKeyboard : false,
				// when this player starts, it will pause other players
				pauseOtherPlayers : true,
				// array of keyboard commands
				keyActions : [],

				success : function(mediaElement, domObject) {

				},
				error : function() {
					//alert('Error setting media!');
				}
			});

			//	////console.log (mediaElement);

			// ... more code ...
			this.player.pause();
			//player.setSrc('mynewfile.mp4');

		},

		player_End : function(event) {

			return (function(el) {
				if (app.current_device === 'mobile') {
					el.style.marginTop = "-20000000px";
					el.playerOut.poster.style.display = 'block';

				} else {

					if ('callback' in el.playerOut) {

						var ar = el.playerOut.callback.split('|');

						switch (ar[0]) {

						case 'goto':

							el.playerOut.scan.className = 'scanner';

							app.router.navigate("s/" + ar[1], {
								trigger : true
							});

							//app.router.slide_to(ar[1]);

							//	this.removeEvent(event.target, 'ended', this.fx);
							//Binder.Unbind(this.id);

							//this.removeEvent

							break;

						}

					}

				}
			})(event.target);
			//this.removeEventListener('ended');

		},

		player_Go : function(event) {

			return (function(el) {
				el.style.display = 'none';
				var player = document.getElementById(el.player);
				player.style.marginTop = "0px";
				return player.play();

			})(event.currentTarget);

		},

		Bind : function(modules_cfg, el, id) {

			this.player = el;

			this.playerOut = {};

			el.style.marginTop = "0px";
			if (app.current_device === 'mobile') {

				this.playerOut = {
					poster : this.poster

				};

				el.style.marginTop = "-20000000px";

				this.poster.player = this.player.id;

				Binder.addEvent(this.poster, 'click', this.player_Go);

				Binder.addEvent(this.player, 'webkitendfullscreen', this.player_End);

			} else {
				this.poster.style.display = 'none';

				if ('opt' in modules_cfg[id].properties) {

					this.scan.className += ' ' + modules_cfg[id].properties.opt.scan;
					//console.log('this.scan.className ',this.scan.className)

				}

				if ('onEnter' in modules_cfg[id].properties.events) {

					if (modules_cfg[id].properties.events.onEnter === 'play') {
						////console.log ("ON ENTER PLAY", this.player.readyState);

						//this.player.oncanplay

						// document.createElement('video');

						//HAVE_ENOUGH_DATA
						//this.player.pause();

						this.player.play();

						if (this.player.error) {
							switch (this.player.error.code) {
							case MEDIA_ERR_ABORTED:
								alert("You stopped the video.");
								break;
							case MEDIA_ERR_NETWORK:
								alert("Network error - please try again later.");
								break;
							case MEDIA_ERR_DECODE:
								alert("Video is broken..");
								break;
							case MEDIA_ERR_SRC_NOT_SUPPORTED:
								alert("Sorry, your browser can't play this video.");
								break;
							}
						}

						//this.player.readyState=4;

						//this.player.setAttribute('controls', true);

						//  this.player.click();

						if (this.player.readyState !== 4) {

							//this.player.pause();
							//this.player.currentTime =0.1;
							//this.player.play();

							// this.player.click();

							//	this.player.load()

							//this.player.load();canplaythroughon

							//this.player.src="./modules/03_stadio/assets/video/filmatoNatalHD_1.mp4";

							//Binder.addEvent(this.poster, 'click', this.player_Go);
							Binder.addEvent(this.player, 'canplaythroughon', this.onCanPlay);
							Binder.addEvent(this.player, 'load', this.onCanPlay);

							/*Binder.addEvent(this.player, 'emptied', function(e) {
							////console.log ('XXXNet', e)

							});*/

							//var p = this.player;

							//this.poster.click();

						} else {

							//video is ready
						}
						//HAVE_ENOUGH_DATA

					}
				}

				if ('onEndPlay' in modules_cfg[id].properties.events) {

					if (modules_cfg[id].properties.events.onEndPlay !== '') {

						_.extend(this.playerOut, {
							callback : modules_cfg[id].properties.events.onEndPlay,
							scan : this.scan,
							//removeEvent : this.removeEvent,
							//fx : endFx,
							id : id
						});

					}
				}

			}

			this.player.playerOut = this.playerOut;
			Binder.addEvent(this.player, 'ended', this.player_End);

		},

		onCanPlay : function(e) {

			/*vid.removeEventListener('canplaythrough', onCanPlay, false);
			vid.removeEventListener('load', onCanPlay, false);*/

			Binder.removeEvent(e.currentTarget, 'canplaythrough', this.onCanPlay);
			Binder.removeEvent(e.currentTarget, 'load', this.onCanPlay);

			//console.log ("CHECK ", e.currentTarget.currentTime, e.currentTarget.paused ,e.currentTarget.readyState);
			//video is ready
			e.currentTarget.play();
		},

		Unbind : function(id) {

			if (_.isUndefined(this.player) || _.isNull(this.player) || _.isEmpty(this.player)) {

				////console.log ('FAKE  , no player found ', this.player);

				return;
			}

			if (!this.player.paused) {

				if ('onLeave' in modules_cfg[id].properties.events) {

					if (modules_cfg[id].properties.events.onLeave === 'stop') {

						if (this.player.networkState === 2 || this.player.networkState === 1) {

							try {
								this.player.currentTime = 0;

								//myVid.addEventListener("canplay",function() { myVid.currentTime = 5;});
								//http://stackoverflow.com/questions/20240088/issue-setting-currenttime-in-html5-Media
								this.player.pause();

							} catch (err) {

							}

						}

					}

				}

			}

			////console.log ('ERASE ', this.player.id);

			Binder.removeEvent(this.poster, 'click', this.player_Go);

			Binder.removeEvent(this.player, 'ended', this.player_End);
			Binder.removeEvent(this.player, 'canplaythrough', this.onCanPlay);
			Binder.removeEvent(this.player, 'load', this.onCanPlay);

			//this.player.onended=null;

			//TODO spoff x tutti i browser prefix su evento!
			Binder.removeEvent(this.player, 'webkitendfullscreen', this.player_End);

			if (app.current_device === 'mobile') {
				this.player.style.marginTop = "-20000000px";
				this.poster.style.display = 'block';

			} else {

				this.player.style.marginTop = "0px";
				this.poster.style.display = 'none';
			}

			//this.player.setCurrentTime(0);

			//////console.log (this.player);
			this.player = {};
			this.poster = {};
			this.scan.className = 'scanner';
			this.scan = {};

		}
	};

	module.exports = VideoMod;

});

